import React from 'react'
import { useTranslation } from 'react-i18next'
import { findSubscriptionPeriodCloseToDate } from '../../utils/warrants'
import { formatMoney } from '../../packages/utils/numberFormatters'
import { WarrantSubscriptionPeriod } from 'types/WarrantEntity'
import { IssueType } from '@finance-lab/utils/types'

function NewsHeadlineTerms({
    row,
}: {
    row: {
        currency: string
        name?: string
        entityType: 'Warrant' | 'Issue'
        companyName: string
        issueData: { type: IssueType }
        warrantData: { name: string; subscriptionPeriods: WarrantSubscriptionPeriod[] }
    }
}) {
    const { entityType, companyName, issueData, warrantData } = row
    const { i18n, t } = useTranslation()
    const locale = i18n.language

    if (entityType === 'Warrant') {
        const subscriptionPeriod = findSubscriptionPeriodCloseToDate(
            { subscriptionPeriods: warrantData.subscriptionPeriods },
            new Date().toISOString(),
        )
        return (
            <span>
                {t('pages.news.headlines.terms.warrant', {
                    companyName,
                    price: formatMoney(subscriptionPeriod.warrantSubPrice, {
                        minDecimals: 2,
                        maxDecimals: 5,
                        locale,
                    }),
                    currency: row.currency,
                    name: row.name || warrantData.name,
                })}
            </span>
        )
    }

    return (
        <span>
            {t('pages.news.headlines.terms.issue', {
                companyName,
                issueType: t(`entities.issueType.values.${issueData.type}`).toLowerCase(),
            })}
        </span>
    )
}

export default NewsHeadlineTerms
